// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f3TcPZ1HHlvkCJq6RFYU {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.LZyJHoOeyHC6LNYxCJIJ  {
    width: 60%;
}

.wCv1YYsLYrCGP0QROdou {
    width: 35%;
}

.ywQ0JJlFxaw6Quab6Pfg {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.ywQ0JJlFxaw6Quab6Pfg button {
    margin-bottom: 0;
}

.brdtN0IEZFHcB3CzxFT6 {
    padding: 4px;
    color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.FGduluRbg_EWB0rYpVlQ {
    margin-bottom: 0;
    margin-top: 0;
}

.FjlhtvSDO4TTS3CUwgN7 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.FjlhtvSDO4TTS3CUwgN7 > div {
    width: 49%;
}

.FjlhtvSDO4TTS3CUwgN7 > div p:last-child {
    margin: 0;
}

.Ae1z09sRprAFiR4ESrZE {
    margin-bottom: 16px;
}

.zU72V6R02gRD_gPD7rM2, .T6ac7PfRPavwud2Vf9XB {
    padding: 16px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]};
    border-radius: 5px;
}

.T6ac7PfRPavwud2Vf9XB {
    margin-top: 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
}

.T6ac7PfRPavwud2Vf9XB p {
    margin: 0 0 8px 0;
    font-weight: 500;
    font-size: 16px;
    text-align: left;
}

.T6ac7PfRPavwud2Vf9XB button {
    margin-bottom: 0;
    width: max-content;
    height: 32px;
    min-width: 0;
    font-size: 16px;
    text-align: left;
}

.xk20frvjOi6ewWxyiiyr {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.xk20frvjOi6ewWxyiiyr p {
    margin: 8px 0;
}

.xk20frvjOi6ewWxyiiyr .hxk_uddtWpV8k4ZAOeIm, .xk20frvjOi6ewWxyiiyr .AhGMISDQM6udSyRbs_MA, .xk20frvjOi6ewWxyiiyr .hxk_uddtWpV8k4ZAOeIm {
    font-size: 16px;
}

.saAvoRDUiQsiMtJzKA6F {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.Us9BkpWyu2aqTdH6tORJ {
    height: 38px;
    align-items: center;
    background: white;
    padding: 0 24px;
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
    font-weight: 400;
    font-size: 16px;
}

.wGCqtzRvBsPybbi9OZc0 {
    width: 50%;
    border-radius: 0 5px 5px 0;
    border-left: 0 solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
}

.c71ZrcRdcvNLv77XwOcX {
    width: 50%;
    border-radius: 5px 0 0 5px;
    border-right: 0 solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]};
}

.gpV_lIFdZHGSkOXpdDxI {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
    font-weight: 500;
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.gDGTeQFBS21eby9DsGQc {
    width: 50%;
}

.gDGTeQFBS21eby9DsGQc > div {
    max-height: 100px;
}

.lwCfc5MPb4KcXVPeZTJB {
    margin: 0 auto;
    padding: 48px 0 48px 48px;
    min-width: 320px;
    width: 45%;
    max-width: 600px;
    box-sizing: border-box;
    background-color: white;
}

.lwCfc5MPb4KcXVPeZTJB .z4pZ4BCeeI4wxnjb1Jwb {
    font-family: Raleway, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
}

.G85BWSi8g9dSN6ktBO1b {
    display: flex;
    align-items: center;
}

.Ln2zrSiCDgan8T1WZPXA {
    display: none;
}

.AhGMISDQM6udSyRbs_MA {
    text-align: right;
}

.tocAGVUJAk2KI7x_Zce9 {
    margin-left: auto;
}

.bVlw5TwhYmqGRGlIvo9w {
    margin-right: 8px;
}

.behEx6W6jiiAvFBW8y2T div + div {
    margin-left: 16px;
}

.xOo49br6M6yHS4rUGOAX {
    border-bottom: 1px solid #E9EFFD;
    padding-bottom: 12px;
    margin-bottom: 12px;
}

.hxk_uddtWpV8k4ZAOeIm {
    color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
}

.GAl74DPqGYQGNpglyKjw {
    font-weight: 500;
}

.oJgKRRfgJQiZVmq0C5d2 {
    font-weight: 500;
    font-size: 24px;
    text-align: right;
}

.ezU3i8f3VvdrDkNyWDKr {
    width: 100%;
    margin-top: 24px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}) {
    .lwCfc5MPb4KcXVPeZTJB {
        padding: 24px;
    }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
    .f3TcPZ1HHlvkCJq6RFYU {
        display: flex;
        flex-direction: column;
    }
    .wCv1YYsLYrCGP0QROdou {
        width: 100%;
        margin-bottom: 24px;
        margin-top: 24px;
    }
    .LZyJHoOeyHC6LNYxCJIJ {
        width: 100%;
    }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
    .Us9BkpWyu2aqTdH6tORJ {
        padding: unset;
    }
    .gDGTeQFBS21eby9DsGQc {
        width: 100%;
    }
    .TW1m9VPAsQo9u6Ntigex h1 {
        text-align: center;
    }

    .lwCfc5MPb4KcXVPeZTJB {
        min-width: unset;
        padding: 16px;

        background-color: white;

        position: relative;
        z-index: 100;

        box-shadow: 0 -5px 15px #f5f8fd;
    }

    .lwCfc5MPb4KcXVPeZTJB {
        margin-top: 90vh;
        width: 100%;
        max-width: unset;
    }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}) {
    .ywQ0JJlFxaw6Quab6Pfg {
        flex-direction: column;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/InvestmentSumup/InvestmentSumup.module.css"],"names":[],"mappings":"AAMA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mDAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8DAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,8DAA4B;IAC5B,mDAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,iEAA+B;AACnC;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,kEAAgC;AACpC;;AAEA;IACI,8DAAiC;IACjC,mDAAmB;IACnB,gBAAgB;IAChB,8DAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mDAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,aAAa;;QAEb,uBAAuB;;QAEvB,kBAAkB;QAClB,YAAY;;QAEZ,+BAA+B;IACnC;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n.formContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.form  {\n    width: 60%;\n}\n\n.amountContainer {\n    width: 35%;\n}\n\n.formHeader {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.formHeader button {\n    margin-bottom: 0;\n}\n\n.required {\n    padding: 4px;\n    color: color-purple;\n}\n\n.requiredTag {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n.formRow {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.formRow > div {\n    width: 49%;\n}\n\n.formRow > div p:last-child {\n    margin: 0;\n}\n\n.formBody {\n    margin-bottom: 16px;\n}\n\n.simulation, .upsell {\n    padding: 16px;\n    background-color: color-purple-bg;\n    border-radius: 5px;\n}\n\n.upsell {\n    margin-top: 24px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n}\n\n.upsell p {\n    margin: 0 0 8px 0;\n    font-weight: 500;\n    font-size: 16px;\n    text-align: left;\n}\n\n.upsell button {\n    margin-bottom: 0;\n    width: max-content;\n    height: 32px;\n    min-width: 0;\n    font-size: 16px;\n    text-align: left;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\n.grid p {\n    margin: 8px 0;\n}\n\n.grid .subtle, .grid .right, .grid .subtle {\n    font-size: 16px;\n}\n\n.buttonContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.button {\n    height: 38px;\n    align-items: center;\n    background: white;\n    padding: 0 24px;\n    border: 1px solid color-gray;\n    color: color-text-subtle;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.buttonRight {\n    width: 50%;\n    border-radius: 0 5px 5px 0;\n    border-left: 0 solid color-gray;\n}\n\n.buttonLeft {\n    width: 50%;\n    border-radius: 5px 0 0 5px;\n    border-right: 0 solid color-gray;\n}\n\n.active {\n    background-color: color-purple-bg;\n    color: color-purple;\n    font-weight: 500;\n    border: 1px solid color-purple;\n}\n\n.choiceButton {\n    width: 50%;\n}\n\n.choiceButton > div {\n    max-height: 100px;\n}\n\n.details {\n    margin: 0 auto;\n    padding: 48px 0 48px 48px;\n    min-width: 320px;\n    width: 45%;\n    max-width: 600px;\n    box-sizing: border-box;\n    background-color: white;\n}\n\n.details .title {\n    font-family: Raleway, sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n}\n\n.row {\n    display: flex;\n    align-items: center;\n}\n\n.hidden {\n    display: none;\n}\n\n.right {\n    text-align: right;\n}\n\n.rightContent {\n    margin-left: auto;\n}\n\n.radio {\n    margin-right: 8px;\n}\n\n.radioContainer div + div {\n    margin-left: 16px;\n}\n\n.separator {\n    border-bottom: 1px solid #E9EFFD;\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n}\n\n.subtle {\n    color: color-text-subtle;\n}\n\n.total {\n    font-weight: 500;\n}\n\n.totalValue {\n    font-weight: 500;\n    font-size: 24px;\n    text-align: right;\n}\n\n.submit {\n    width: 100%;\n    margin-top: 24px;\n}\n\n@media screen and (max-width: laptop) {\n    .details {\n        padding: 24px;\n    }\n}\n\n@media screen and (max-width: tablet-l) {\n    .formContainer {\n        display: flex;\n        flex-direction: column;\n    }\n    .amountContainer {\n        width: 100%;\n        margin-bottom: 24px;\n        margin-top: 24px;\n    }\n    .form {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: tablet) {\n    .button {\n        padding: unset;\n    }\n    .choiceButton {\n        width: 100%;\n    }\n    .content h1 {\n        text-align: center;\n    }\n\n    .details {\n        min-width: unset;\n        padding: 16px;\n\n        background-color: white;\n\n        position: relative;\n        z-index: 100;\n\n        box-shadow: 0 -5px 15px #f5f8fd;\n    }\n\n    .details {\n        margin-top: 90vh;\n        width: 100%;\n        max-width: unset;\n    }\n}\n\n@media screen and (max-width: mobile-xs) {\n    .formHeader {\n        flex-direction: column;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"formContainer": `f3TcPZ1HHlvkCJq6RFYU`,
	"form": `LZyJHoOeyHC6LNYxCJIJ`,
	"amountContainer": `wCv1YYsLYrCGP0QROdou`,
	"formHeader": `ywQ0JJlFxaw6Quab6Pfg`,
	"required": `brdtN0IEZFHcB3CzxFT6`,
	"requiredTag": `FGduluRbg_EWB0rYpVlQ`,
	"formRow": `FjlhtvSDO4TTS3CUwgN7`,
	"formBody": `Ae1z09sRprAFiR4ESrZE`,
	"simulation": `zU72V6R02gRD_gPD7rM2`,
	"upsell": `T6ac7PfRPavwud2Vf9XB`,
	"grid": `xk20frvjOi6ewWxyiiyr`,
	"subtle": `hxk_uddtWpV8k4ZAOeIm`,
	"right": `AhGMISDQM6udSyRbs_MA`,
	"buttonContainer": `saAvoRDUiQsiMtJzKA6F`,
	"button": `Us9BkpWyu2aqTdH6tORJ`,
	"buttonRight": `wGCqtzRvBsPybbi9OZc0`,
	"buttonLeft": `c71ZrcRdcvNLv77XwOcX`,
	"active": `gpV_lIFdZHGSkOXpdDxI`,
	"choiceButton": `gDGTeQFBS21eby9DsGQc`,
	"details": `lwCfc5MPb4KcXVPeZTJB`,
	"title": `z4pZ4BCeeI4wxnjb1Jwb`,
	"row": `G85BWSi8g9dSN6ktBO1b`,
	"hidden": `Ln2zrSiCDgan8T1WZPXA`,
	"rightContent": `tocAGVUJAk2KI7x_Zce9`,
	"radio": `bVlw5TwhYmqGRGlIvo9w`,
	"radioContainer": `behEx6W6jiiAvFBW8y2T`,
	"separator": `xOo49br6M6yHS4rUGOAX`,
	"total": `GAl74DPqGYQGNpglyKjw`,
	"totalValue": `oJgKRRfgJQiZVmq0C5d2`,
	"submit": `ezU3i8f3VvdrDkNyWDKr`,
	"content": `TW1m9VPAsQo9u6Ntigex`
};
export default ___CSS_LOADER_EXPORT___;
